<header class="public-ticket-header">
  <div class="public-ticket-header__inner">
    <img src="assets/images/logo.svg" alt="Makani" height="32" />

    @if (ticketCode) {
      <span class="public-ticket-header__code">
        {{ 'HOME.TICKET_NO_PREFIX' | translate }} {{ ticketCode }}
      </span>
    }
  </div>
</header>
